module.exports = __webpack_public_path__ + "assets/images/project/menu/brunei-thumb.jpg?v=a8176bd1";